const state = () => ({
  questionnaireUserStates: [],
});

const getters = {
  all: (state) => state.questionnaireUserStates,
};

const mutations = {
  set(state, questionnaireUserStates = []) {
    state.questionnaireUserStates = questionnaireUserStates;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
